import { ModalForm, ProFormTextArea } from '@ant-design/pro-form'
import { useTranslation } from 'react-i18next'
import { Button } from 'antd'
import './DeleteModalForm.scss'

export const DeleteModalForm = ({
    type,
    mmsiType,
    typeValue,
    deleteId,
    setDeleteId,
    inputName,
    setInputName,
    isConfirmDelete,
    setIsConfirmDelete,
    handleDelete,
    paginatedData,
    isCopyId,
    setIsCopyId,
    projectListData,
    handleCopy,
}) => {
    const { t } = useTranslation()

    return (
        <ModalForm
            title={Boolean(isCopyId) ? t('common.copyOld') : t('common.delete')}
            visible={Boolean(isCopyId) ? Boolean(isCopyId) : Boolean(deleteId)} // 强制转换类型为布尔值，不能删！
            onVisibleChange={boolean => {
                if (!boolean) {
                    if (Boolean(isCopyId)) {
                        setIsCopyId('')
                    } else {
                        setDeleteId('')
                    }
                }
            }}
            modalProps={{
                destroyOnClose: true,
                maskClosable: false,
                wrapClassName: 'deleteModal',
                onCancel: () => {
                    if (Boolean(isCopyId)) {
                        setIsCopyId('')
                        setInputName('')
                        setIsConfirmDelete(false)
                    } else {
                        setDeleteId('')
                        setInputName('')
                        setIsConfirmDelete(false)
                    }
                },
            }}
            submitter={{
                render: (props, doms) => [
                    <Button
                        type='button'
                        key='cancel'
                        onClick={() => {
                            if (Boolean(isCopyId)) {
                                setIsCopyId('')
                                setInputName('')
                                setIsConfirmDelete(false)
                            } else {
                                setDeleteId('')
                                setInputName('')
                                setIsConfirmDelete(false)
                            }
                        }}
                    >
                        {t('common.cancel')}
                    </Button>,
                    <Button
                        type='primary'
                        key='submit'
                        className={`deleteBtn ${isConfirmDelete ? 'confirmDeleteBtn' : ''}`}
                        onClick={() => {
                            if (isConfirmDelete) {
                                if (Boolean(isCopyId)) {
                                    if (type === 'LogSettings') {
                                        handleCopy()
                                    } else {
                                        handleCopy(isCopyId)
                                    }
                                    setIsCopyId('')
                                    setInputName('')
                                    setIsConfirmDelete(false)
                                } else {
                                    handleDelete(deleteId)
                                    setDeleteId('')
                                    setInputName('')
                                    setIsConfirmDelete(false)
                                }
                            }
                        }}
                    >
                        {Boolean(isCopyId) ? t('common.sure') : t('common.confirmDelete')}
                    </Button>,
                ],
            }} // 定制提交按钮
        >
            <div className='content'>
                <div className='text'>
                    <div className='one'>
                        {mmsiType === 'Location'
                            ? t(`${type}.copyTips2MMSI`)
                            : Boolean(isCopyId)
                            ? t(`${type}.copyTips2`)
                            : t(`${type}.tips2`)}
                    </div>
                    <div className='two'>
                        <div className='three'>
                            {Boolean(isCopyId) ? t(`${type}.copyTips3`) : t(`${type}.copyTips3`)}
                        </div>
                        <span className='four'>
                            {Boolean(isCopyId)
                                ? projectListData?.data?.find(item => String(item.id) === isCopyId)?.projectName ??
                                  '默认模板'
                                : paginatedData?.find(item => String(item.id) === deleteId)?.[typeValue]}
                        </span>
                    </div>
                </div>
                <Button
                    className='quickInput'
                    onClick={() => {
                        if (Boolean(isCopyId)) {
                            setInputName(
                                projectListData?.data?.find(item => String(item.id) === isCopyId)?.projectName ??
                                    '默认模板'
                            )
                            setIsConfirmDelete(true)
                        } else {
                            setInputName(paginatedData?.find(item => String(item.id) === deleteId)?.[typeValue])
                            setIsConfirmDelete(true)
                        }
                    }}
                >
                    {t('common.quickInput')}
                </Button>
                <ProFormTextArea
                    classNames='confirmationBox'
                    name='deleteName'
                    fieldProps={{
                        placeholder: Boolean(isCopyId) ? t(`${type}.tips11`) : t(`${type}.tips4`),
                        autoSize: true,
                        value: inputName,
                        onChange: e => {
                            const value = e.target.value
                            setInputName(value)
                            let deleteName
                            if (Boolean(isCopyId)) {
                                deleteName =
                                    projectListData?.data?.find(item => String(item.id) === isCopyId)?.projectName ??
                                    '默认模板'
                            } else {
                                deleteName = paginatedData?.find(item => String(item.id) === deleteId)?.[typeValue]
                            }
                            if (value === deleteName) {
                                setIsConfirmDelete(true)
                            } else {
                                setIsConfirmDelete(false)
                            }
                        },
                    }}
                />
            </div>
        </ModalForm>
    )
}
